(function(angular) {
	angular.module('bizPartEngage').controller('modules.cms.page', pageController);
    pageController.$inject = ["$rootScope", "modules.cms.service", "$stateParams", "container", "bizContainerService", "bizContainerUrls", "bizContainerSettings", "MetadataService", "$filter"];

    function pageController($rootScope, cmsService, $stateParams, container, bizContainerService, bizContainerUrls, bizContainerSettings, MetadataService, $filter) {
        var vm = this;
        vm.PageIdentifier = $stateParams.id;

        vm.GetCMSPage = GetCMSPage;

        bizContainerSettings.ContainerRefererType = "CMS";

        vm.uiOnParamsChanged = function (changedParams, transition) {
        	$rootScope.$broadcast('DYNAMIC_PARAMS_CHANGED', changedParams);
        }

        function GetCMSPage() {
        	vm.GettingCMSPage = true;

            cmsService.GetCMSPage(vm.PageIdentifier).then(GetCmsPageSuccess, GetCmsPageReject);

            function GetCmsPageReject(response) {
                vm.NoAccess = true;
            }

            function GetCmsPageSuccess(response) {
        		vm.Page = response.data;
        		vm.Page.Container = new container(vm.Page.Container);
                
        		$rootScope.DisableMainMenuSticky = !$rootScope.menuSettings.IsSticky;
        		vm.GettingCMSPage = false;

        		if (vm.Page.Container.hasStickyNavigation())
        			$rootScope.DisableMainMenuSticky = true;

                var imageModules = vm.Page.Container.getModules("IMAGE");
                var imageUrl = "";
                if (imageModules.length > 0 && imageModules[0].Content.ImageUrl.length > 0) {
                    imageUrl = imageModules[0].Content.ImageUrl;
                }
                
                MetadataService.setMetaTags({
                    title: vm.Page.Title,
                    description: vm.Page.Description,
                    keywords: vm.Page.Keywords,
                    img: imageUrl
                });
            }
        }

        vm.$onInit = function() {
        	vm.GetCMSPage();
        }
    }

})(window.angular);
